import BaseService from "./Base.Service";

class QuizService extends BaseService {
	constructor() {
		super("quiz");
	}

	// Criar e editar com a mensagem do back no erro (o update da base engole o erro).
	// Em erro, o toast sai aqui e volta { error: true }.
	async save(data, id = null) {
		try {
			const response = id
				? await this.conn.axios.put(`/quiz/${id}`, data)
				: await this.conn.axios.post(`/quiz`, data);
			return response.data;
		} catch (err) {
			return this.sendError("Erro ao salvar o questionário", false, err);
		}
	}

	// Ativa ou desativa sem mexer nas perguntas: "ATIVO" ou "INATIVO"
	async updateStatus(id, status) {
		try {
			const { data } = await this.conn.axios.put(`/quiz/${id}/status`, { status });
			return data;
		} catch (err) {
			return this.sendError("Erro ao mudar o status do questionário", false, err);
		}
	}
}

export default QuizService;
